// axiosClient
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';


const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';
const apiVersion = process.env.REACT_APP_API_VERSION || 'v1';

const instance: AxiosInstance = axios.create({
  baseURL: `${apiBaseUrl}/${apiVersion}`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const setAuthToken = (token?: string | null) => {
  if (token) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete instance.defaults.headers.common['Authorization'];
  }
};

const handleResponse = <T>(response: AxiosResponse<T>): T => response.data;

export const get = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<T> => {
  const res = await instance.get<T>(url, config);
  return handleResponse(res);
};

export const post = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  const res = await instance.post<T>(url, data, config);
  return handleResponse(res);
};

export const put = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  const res = await instance.put<T>(url, data, config);
  return handleResponse(res);
};

export const patch = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<T> => {
  const res = await instance.patch<T>(url, data, config);
  return handleResponse(res);
};

export const del = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<T> => {
  const res = await instance.delete<T>(url, config);
  return handleResponse(res);
};

export default instance;
